import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import IconLoader from "@/features/Common/components/IconLoader";
import ScreenWrapper from "../../Common/ScreenWrapper";
import ExerciseCard from "./InfoCard";
import ExerciseChart, { ExerciseChartDataPoint } from "./ExerciseChart";
import HereToHelpCard from "../../HereToHelpCard";
import { WellnessScoreStatus } from "../../Common/types";

export interface ExerciseScreenProps {
  chartData: ExerciseChartDataPoint[];
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onBack?: () => void;
  onOpenLifestyle?: () => void;
}

export default function ExerciseScreen({
  chartData,
  status,
  lastUpdated,
  onBack,
  onOpenLifestyle,
}: ExerciseScreenProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = onBack ?? (() => navigate(-1));

  const currentPoint =
    chartData.find((p) => p.isSelected) ?? chartData[chartData.length - 1];
  const minutesPerWeek = currentPoint?.minutesPerWeek ?? 0;

  return (
    <ScreenWrapper onBack={handleBack} title={t("Exercise.screenTitle")}>
      <Stack gap={2}>
        <ExerciseCard
          minutesPerWeek={minutesPerWeek}
          valueDisplayLabel={currentPoint?.valueDisplayLabel}
          lastUpdated={lastUpdated}
        />
        <ExerciseChart data={chartData} />
        <HereToHelpCard
          title={t("HereToHelpCard.title")}
          description={t("HereToHelpCard.description")}
          button={{
            text: t("HereToHelpCard.button.text"),
            icon: <IconLoader icon="SpeakToADoctorIcon" />,
          }}
        />
      </Stack>
    </ScreenWrapper>
  );
}
